export default async function InsertLandOwnerWithIdentityFiles(sendForm) {
    let url = window.RealestateService+  `/api/Land/InsertLandOwnerWithIdentityFiles`
    let head = {
        // "content-type":"multipart/form-data",
        "accept":"*/*"
    }
    let data ={}
    let response  = await fetch(url, {
        method:"POST",
        headers:head,
        body:sendForm
    }).then(res=>res.json()).then(data)

    return response
}